import { Swiper } from './swiper-DDnfT8S0.js';
import { A as A11y } from './a11y-DMhWZZ38.js';
import './utils-CPPFXbqB.js';

class QuickLinksSlider extends HTMLElement {
  #swiper = this.querySelector('.swiper');

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this.#swiper, {
      modules: [A11y],
      slidesPerView: 'auto',
      spaceBetween: 8,
    });
  }
}

customElements.define('quick-links-slider', QuickLinksSlider);
